import React, { Component } from "react";
import AdminSidebar from "../sidebar/admin_sidebar";
import AdminHeader from "../header/admin_header";
import config from "../../config/config.json";
import axios from "axios";
import { sweetAlert } from "../../utils/UniversalFunction";
import "./control.css";
import { authenticationService } from "../../_services/authentication";
const currentUser = authenticationService.currentUserValue;

export default class AddNewCompanyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      loading: false,
      type: "",
      question: "",
      uuid: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit(event) {
    let uri = window.location.pathname.split("/");
    let uuid = uri[2];
    event.preventDefault();
    this.setState({ submitted: true });
    const { type, question } = this.state;
    const headers = {
      Authorization: `Bearer ${currentUser.data.token}`,
      Accept: "application/json",
    };
    axios
      .post(
        config.API_URL + "addNewSpecificPolicy",
        {
          uuid: uuid,
          type: type,
          question: question,
        },
        { headers }
      )
      .then((response) => {
        sweetAlert("success", response.data.message);
        setTimeout(() => {
          this.props.history.push(`/companies/${uuid}/company_policies`);
        }, 1000);
        console.log("response", response);
      })
      
      .catch(function (error) {
        if (error.response) {
          sweetAlert("error", error.response.data.message);
        }
      });
  }

  componentDidMount() {
    
  }

  render() {
    return (
      <div>
        <AdminSidebar dataFromParent={this.props.location.pathname} />
        <AdminHeader />
        <div className="main_wrapper">
          <div className="inner_wraapper">
            <div className="container-fluid">
              <section className="d_text">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="col-sm-12">
                        <div className="color_div_on framwork_2">
                          <div className="business_detail">
                            <div className="">
                              <div className="saved_cards">
                                <form name="form" onSubmit={this.handleSubmit}>
                                  <div className="business_detail">
                                    <div className="heading">
                                      <h4>Add New Policy</h4>
                                    </div>
                                    <hr className="line"></hr>

                                    <div className="row">
                                      <div className="col-lg-12 col-xs-12">
                                        <div className="form-group">
                                          <label
                                            htmlFor="title"
                                            className="mb-2"
                                          >
                                            Policy Category*
                                          </label>
                                          <select
                                            onChange={this.handleChange}
                                            name="type"
                                            className="select_one industrylist"
                                          >
                                          <option>Select Category</option>
                                            <option value="governancePolicy">Governance Policy</option>
                                            <option value="socialPolicy">Social Policy</option>
                                            <option value="cyberAndTechnology">Cyber & Technology</option>
                                            <option value="healthAndSafetyPolicy">Health & Safety Policy</option>
                                            <option value="environmentalPolicy">Environmental Policy</option>
                                            <option value="otherPolicy">Other Policy</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label
                                          htmlFor="question"
                                          className="mb-2"
                                        >
                                          Policy Name*
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control py-3"
                                          id="question"
                                          placeholder="Enter Policy Name"
                                          name="question"
                                          onChange={this.handleChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="global_link mx-0 my-3">
                                    <button
                                      type="submit"
                                      className="page_width page_save"
                                    >
                                      ADD NOW
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
